const assertUnreachable = (_x, error) => {
    if (typeof error === 'string') {
        throw Error(error);
    }
    else {
        throw error;
    }
};
export default assertUnreachable;
//# sourceMappingURL=assertUnreachable.js.map